/* ==========================================================================
   Homellence – X6 (Runde 28): Farbkreise auf der Produktkarte

   Ein Klick auf einen Kreis wechselt Bild, Preis, Variantenname und die
   Ziele der Karte – ohne Seitenwechsel, wie auf der Produktseite.

   B1 (Runde 32) – **Die Wahl wird hier gerechnet, nicht beim Rendern.**

   Bis Runde 31 trug jeder Kreis eine fertig aufgelöste Zielvariante als
   `data`-Attribut; das Skript las sie nur ab. Das war richtig, solange es
   eine Reihe Kreise gab. Bei zweien – Korb und Brett am Waschtag-Set –
   stimmte es nicht mehr: Liquid rechnet gegen die Variante, die beim
   Rendern gezeigt wurde, also gegen die Vorgabe der jeweils anderen Reihe.
   Jeder Klick setzte die andere Reihe zurück, und zwei der vier
   Kombinationen waren unerreichbar.

   Welche Variante ein Kreis meint, hängt davon ab, was in den übrigen
   Reihen gerade gewählt ist. Diesen Zustand kennt nur der Browser. Die
   Karte bringt deshalb ihre Varianten als Tabelle mit; gesucht wird beim
   Klick.

   Die Regel ist dieselbe wie in A2 (Runde 31), nur auf jede Option
   angewandt:

     1. die Variante, die den angeklickten Wert trägt **und** in allen
        übrigen Optionen mit der gerade gezeigten übereinstimmt – auch wenn
        sie ausverkauft ist. Ausverkauftes soll sichtbar bleiben.
     2. gibt es die Kombination nicht: die erste **lieferbare** mit diesem
        Wert.
     3. gibt es keine lieferbare: die erste mit diesem Wert überhaupt.

   Ohne JavaScript bleibt die Karte, was sie war: Die Kreise sind dann
   Knöpfe ohne Wirkung, und wer etwas ansehen will, klickt auf Bild oder
   Titel. Kein Zustand geht verloren – auch vorher war `data-href` kein
   Link, sondern nur Futter für dieses Skript.
   ========================================================================== */
(function () {
  'use strict';

  class HlProductCard extends HTMLElement {
    connectedCallback() {
      this.swatches = Array.prototype.slice.call(
        this.querySelectorAll('[data-hl-card-swatch]')
      );
      if (!this.swatches.length) return;

      var tabelle = this.querySelector('[data-hl-card-variants]');
      if (!tabelle) return;
      try {
        this.varianten = JSON.parse(tabelle.textContent);
      } catch (fehler) {
        /* Lieber gar keine Wirkung als eine falsche: Ohne Tabelle bleiben
           die Kreise, was sie ohne Skript auch wären. */
        return;
      }
      if (!this.varianten || !this.varianten.length) return;

      this.aktuell = this.ausId(this.getAttribute('data-hl-card-variant')) || this.varianten[0];

      this.bild = this.querySelector('.hl-card__img') || this.querySelector('.hl-card__media img');
      this.preis = this.querySelector('[data-hl-card-price]');
      this.variantenName = this.querySelector('[data-hl-card-variant-name]');
      this.links = Array.prototype.slice.call(this.querySelectorAll('[data-hl-card-link]'));

      var self = this;
      this.swatches.forEach(function (knopf) {
        knopf.addEventListener('click', function () {
          self.waehle(knopf);
        });
      });
    }

    ausId(id) {
      if (!id) return null;
      for (var i = 0; i < this.varianten.length; i++) {
        if (String(this.varianten[i].id) === String(id)) return this.varianten[i];
      }
      return null;
    }

    /* Die Regel aus dem Kopf dieser Datei, in dieser Reihenfolge. */
    finde(wunsch, stelle, wert) {
      var i;
      for (i = 0; i < this.varianten.length; i++) {
        var v = this.varianten[i];
        var gleich = v.o.length === wunsch.length;
        for (var k = 0; gleich && k < wunsch.length; k++) {
          if (v.o[k] !== wunsch[k]) gleich = false;
        }
        if (gleich) return v;
      }
      for (i = 0; i < this.varianten.length; i++) {
        if (this.varianten[i].o[stelle] === wert && this.varianten[i].a) return this.varianten[i];
      }
      for (i = 0; i < this.varianten.length; i++) {
        if (this.varianten[i].o[stelle] === wert) return this.varianten[i];
      }
      return null;
    }

    waehle(knopf) {
      var stelle = parseInt(knopf.getAttribute('data-option-position'), 10) - 1;
      var wert = knopf.getAttribute('data-option-value');
      if (!(stelle >= 0) || wert === null) return;

      var wunsch = this.aktuell.o.slice();
      wunsch[stelle] = wert;

      var treffer = this.finde(wunsch, stelle, wert);
      if (!treffer) return;
      this.aktuell = treffer;

      if (this.bild && treffer.s) {
        /* Erst `srcset`, dann `src`: Andersherum lädt der Browser kurz das
           alte `srcset` weiter, weil es die stärkere Angabe ist. */
        if (treffer.ss) this.bild.srcset = treffer.ss;
        this.bild.src = treffer.s;
        /* Das `sizes` der Karte bleibt stehen – die Kachelbreite ändert
           sich durch die Farbwahl nicht. */
      }

      /* P1 (Cowork, 27.09.2026) · Laufband-Format (`hl-card--lb`): Die
         Tabelle trägt dort zusätzlich `f` (randlos oder freigestellt) und
         `b` (Etikett der Variante). Beides wandert mit, sonst stünde
         „Bestseller“ auf einer Farbe, die keiner ist. Ohne die Schlüssel
         bleibt alles wie vorher. */
      if (typeof treffer.f === 'string') {
        var buehne = this.querySelector('.hl-card__media');
        if (buehne) buehne.classList.toggle('hl-card__media--cover', treffer.f === 'cover');
      }
      if (typeof treffer.b === 'string') {
        var etikett = this.querySelector('[data-hl-card-badge]');
        if (etikett) {
          etikett.textContent = treffer.b;
          etikett.hidden = !treffer.b;
        }
      }

      if (this.preis && treffer.p) {
        this.preis.textContent = treffer.p;
        this.preis.classList.toggle('hl-card__price--gone', treffer.a === false);
      }

      if (this.variantenName && treffer.n) this.variantenName.textContent = treffer.n;

      if (treffer.u) {
        this.links.forEach(function (link) {
          link.setAttribute('href', treffer.u);
        });
      }

      /* `aria-pressed` sagt, welcher Kreis gewählt ist; `aria-current` trägt
         den Ring aus dem Stylesheet. Beides muss mitwandern, sonst zeigt die
         Karte eine Farbe und meldet eine andere.

         B1 (Runde 32) · Abgeglichen wird gegen die **gefundene** Variante,
         nicht gegen den angeklickten Knopf. Bei zwei Reihen hat jede Reihe
         ihren eigenen gewählten Kreis – und wenn Stufe 2 oder 3 der Regel
         greift, kann sich dabei auch der Wert einer anderen Reihe ändern.
         Vorher wurden alle Kreise der Karte zurückgesetzt und nur der
         angeklickte gesetzt; in der zweiten Reihe war dann keiner markiert. */
      var werte = treffer.o;
      this.swatches.forEach(function (anderer) {
        var pos = parseInt(anderer.getAttribute('data-option-position'), 10) - 1;
        var gewaehlt = werte[pos] === anderer.getAttribute('data-option-value');
        anderer.setAttribute('aria-pressed', gewaehlt ? 'true' : 'false');
        if (gewaehlt) anderer.setAttribute('aria-current', 'true');
        else anderer.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('hl-product-card')) {
    customElements.define('hl-product-card', HlProductCard);
  }
})();
